import type { FC } from "react";
import type { EventListGridItem } from "src/http/api-types";
import { ChevronIcon } from "src/shared/components/ChevronIcon";
import { useContent } from "src/shared/components/content";
import { ExploreButton } from "./ExploreButton";
import { ExploreDateCard } from "./ExploreDateCard";
import {
  buttonWrapper,
  dateCardWrapper,
  eventDetails,
  eventInfo,
  eventLink,
  eventTitle,
} from "./ExploreEventItem.styled";

interface ExploreEventItemProps {
  event: EventListGridItem;
  onClick?: () => void;
}

export const ExploreEventItem: FC<ExploreEventItemProps> = ({ event, onClick }) => {
  const seeTicketsText = useContent("cid$#3177387#");
  // Format subtitle: time | venue | location
  const subtitle = [event.formattedTime, event.venueName, event.formattedVenueLocation].filter(Boolean).join(" | ");

  return (
    <div>
      <a href={event.url ?? "#"} onClick={onClick} className={eventLink}>
        <div className={dateCardWrapper}>
          <ExploreDateCard event={event} brandColors />
        </div>
        <div className={eventInfo}>
          <div className={eventTitle}>{event.name}</div>
          <div className={eventDetails}>{subtitle}</div>
        </div>
        <div className={buttonWrapper}>
          <ExploreButton href={event.url ?? "#"} icon={<ChevronIcon />}>
            {seeTicketsText}
          </ExploreButton>
        </div>
      </a>
    </div>
  );
};
